import { Box, Container, Typography, Button } from "@mui/material";

import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

import servicesHeroBg from "../../assets/images/services_hero_bg.png";
import servicesHeroBgm from "../../assets/images/services_hero_bg_m.png";

export default function ServicesHero() {
  return (
    <Box
      sx={{
        position: "relative",

        overflow: "hidden",

        backgroundImage: {
          xs: `url(${servicesHeroBgm})`,
          md: `url(${servicesHeroBg})`,
        },

        backgroundSize: "cover",

        backgroundPosition: "center",

        backgroundRepeat: "no-repeat",

        py: {
          xs: 4,
          md: 6,
        },
      }}
    >
      <Container maxWidth="xl">
        <Box
          sx={{
            display: "flex",

            flexDirection: {
              xs: "column",
              lg: "row",
            },

            alignItems: "center",

            gap: {
              xs: 5,
              md: 8,
            },
          }}
        >
          {/* LEFT CONTENT */}

          <Box
            sx={{
              flex: 1,

              textAlign: {
                xs: "center",
                lg: "left",
              },
            }}
          >
            {/* Badge */}

            <Box
              sx={{
                display: "inline-flex",

                px: 2.5,

                py: 1,

                borderRadius: "50px",

                background: "rgba(0,87,255,.08)",

                color: "#0057FF",

                fontSize: "12px",

                fontWeight: 800,

                letterSpacing: "1px",

                textTransform: "uppercase",
              }}
            >
              Our Services
            </Box>

            {/* Heading */}

            <Typography
              sx={{
                mt: 2,

                fontWeight: 900,

                lineHeight: 1.05,

                color: "#07122F",

                fontSize: {
                  xs: "32px",
                  sm: "32px",
                  md: "56px",
                  lg: "56px",
                },
                display: "block",
              }}
            >
              Professional
              <Box
                component="span"
                sx={{
                  background: "linear-gradient(135deg,#0057FF,#1DB6FF)",

                  WebkitBackgroundClip: "text",

                  WebkitTextFillColor: "transparent",
                }}
              >
                {" "}
                Care{" "}
              </Box>
              Services
            </Typography>

            {/* Description */}

            <Typography
              sx={{
                mt: 3,

                maxWidth: {
                  xs: "100%",
                  lg: "650px",
                },

                mx: {
                  xs: "auto",
                  lg: 0,
                },

                color: "#64748B",

                lineHeight: 1.8,

                fontSize: {
                  xs: "13px",
                  sm: "14px",
                  md: "16px",
                },
              }}
            >
              Professional dry cleaning, laundry, alterations, shoe repair,
              custom printing, wedding dress care, rug cleaning and specialty
              services available throughout Durham Region.
            </Typography>

            {/* Buttons */}

            <Box
              sx={{
                mt: 4,

                display: "flex",

                justifyContent: {
                  xs: "center",
                  lg: "flex-start",
                },

                alignItems: "center",

                gap: 2,

                flexWrap: "nowrap",
              }}
            >
              {/* EXPLORE SERVICES */}

              <Button
                endIcon={<ArrowForwardIcon />}
                sx={{
                  height: {
                    xs: 42,
                    md: 56,
                  },

                  minWidth: {
                    xs: "48%",
                    md: 240,
                  },

                  px: {
                    xs: 2,
                    md: 4,
                  },

                  borderRadius: "50px",

                  background: "linear-gradient(135deg,#0057FF,#1DB6FF)",

                  color: "#fff",

                  fontWeight: 800,

                  fontSize: {
                    xs: "12px",
                    md: "15px",
                  },

                  textTransform: "none",

                  boxShadow: "0 15px 35px rgba(0,87,255,.25)",

                  "&:hover": {
                    background: "linear-gradient(135deg,#0057FF,#1DB6FF)",

                    transform: "translateY(-2px)",
                  },
                }}
              >
                Explore Services
              </Button>

              {/* WHATSAPP */}

              <Button
                startIcon={<WhatsAppIcon />}
                href="https://wa.me/+19054283542"
                target="_blank"
                component="a"
                sx={{
                  height: {
                    xs: 42,
                    md: 56,
                  },

                  minWidth: {
                    xs: "48%",
                    md: 220,
                  },

                  px: {
                    xs: 2,
                    md: 4,
                  },

                  borderRadius: "50px",

                  background: "rgba(255,255,255,.95)",

                  color: "#25D366",

                  fontWeight: 800,

                  fontSize: {
                    xs: "12px",
                    md: "15px",
                  },

                  textTransform: "none",

                  border: "2px solid rgba(37,211,102,.25)",

                  boxShadow: "0 12px 30px rgba(37,211,102,.10)",

                  "& .MuiButton-startIcon": {
                    color: "#25D366",
                  },

                  "&:hover": {
                    background: "rgba(37,211,102,.08)",

                    border: "2px solid rgba(37,211,102,.45)",

                    transform: "translateY(-2px)",

                    boxShadow: "0 18px 35px rgba(37,211,102,.18)",
                  },
                }}
              >
                WhatsApp Us
              </Button>
            </Box>

            {/* Stats */}

            <Box
              sx={{
                mt: 5,

                display: "flex",

                justifyContent: {
                  xs: "center",
                  lg: "flex-start",
                },

                gap: {
                  xs: 3,
                  md: 5,
                },

                flexWrap: "wrap",
              }}
            >
              {[
                ["1000+", "Happy Customers"],
                ["10+", "Cleaning Services"],
                ["10+", "Service Areas"],
              ].map((item) => (
                <Box key={item[0]}>
                  <Typography
                    sx={{
                      fontWeight: 900,

                      color: "#0057FF",

                      fontSize: {
                        xs: "26px",
                        md: "40px",
                      },
                    }}
                  >
                    {item[0]}
                  </Typography>

                  <Typography
                    sx={{
                      color: "#64748B",

                      fontSize: {
                        xs: "13px",
                        md: "15px",
                      },
                    }}
                  >
                    {item[1]}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Box>

          {/* RIGHT VISUAL */}

          <Box
            sx={{
              flex: 1,

              width: "100%",

              minHeight: {
                xs: 300,
                md: 600,
              },

              borderRadius: "40px",

              position: "relative",

              overflow: "hidden",

              //   background:
              //     "linear-gradient(135deg,rgba(255,255,255,.7),rgba(255,255,255,.35))",

              //   backdropFilter: "blur(20px)",

              //   border: "1px solid rgba(255,255,255,.8)",

              //   boxShadow: "0 25px 70px rgba(0,87,255,.08)",
            }}
          >
            {/* Main Service Image */}

            {/* <Box
              sx={{
                position: "absolute",

                inset: 0,

                backgroundImage: "url('/images/service-hero-main.png')",

                backgroundSize: "cover",

                backgroundPosition: "center",
              }}
            /> */}

            {/* Floating Cards */}

            {/* <Box
              sx={{
                position: "absolute",

                top: 30,

                left: 30,

                px: 2,

                py: 1.5,

                borderRadius: "18px",

                background: "rgba(255,255,255,.9)",

                backdropFilter: "blur(12px)",

                fontWeight: 800,

                color: "#07122F",
              }}
            >
              👔 Dry Cleaning
            </Box>

            <Box
              sx={{
                position: "absolute",

                bottom: 40,

                left: 40,

                px: 2,

                py: 1.5,

                borderRadius: "18px",

                background: "rgba(255,255,255,.9)",

                backdropFilter: "blur(12px)",

                fontWeight: 800,

                color: "#07122F",
              }}
            >
              👟 Shoe Cleaning
            </Box>

            <Box
              sx={{
                position: "absolute",

                top: 80,

                right: 30,

                px: 2,

                py: 1.5,

                borderRadius: "18px",

                background: "rgba(255,255,255,.9)",

                backdropFilter: "blur(12px)",

                fontWeight: 800,

                color: "#07122F",
              }}
            >
              👰 Wedding Dress Care
            </Box> */}
          </Box>
        </Box>
      </Container>
    </Box>
  );
}